import { render, staticRenderFns } from "./modal_add_trend.vue?vue&type=template&id=1251e5d4&scoped=true&"
import script from "./modal_add_trend.vue?vue&type=script&lang=js&"
export * from "./modal_add_trend.vue?vue&type=script&lang=js&"
import style0 from "./modal_add_trend.vue?vue&type=style&index=0&id=1251e5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1251e5d4",
  null
  
)

export default component.exports